import "library/styles/components/stripe-modal.scss";
import React, { Component } from 'react';
import { StripeProvider, Elements } from 'react-stripe-elements';
import { LogoSvg } from 'library/components/logo';
import StripeForm from 'library/components/stripe-form';
import Loading from 'library/components/loading';
import Ajax from 'library/util/ajax';
import Stripe from 'library/helpers/stripe';

const Wait = (time) => new Promise((resolve, reject) => {
  setTimeout(resolve, time);
})

export default class StripeModal extends Component {
  constructor(props, ...params) {
    super(props, ...params);

    this.state.email = props.email;
    this.state.name = props.name;
  }

  state = {
    isActive: false,
    loading: true,
    processing: false,
    name: '',
    email: ''
  }

  handleChange = ({ target }) => {
    const { name, value } = target;

    this.setState({
      [name]: value
    })
  }

  setActive = (active) => {
    this.setState({
      isActive: active
    })
  }

  componentWillMount() {
    this.load();
  }

  load = async () => {
    this.setState({
      loading: true
    })

    await Stripe.inject();

    this.setState({
      loading: false
    })
  }

  close = () => {
    if (this.state.isActive && !confirm("Are you sure?")) {
      return;
    }

    this.props.close();
  }

  handleComplete = async (token) => {
    try {
      const { data } = await Ajax.post('/api/v1/plans/pairin-courses/subscriptions', {
        email: this.state.email,
        token: token.id
      });
      return this.props.onComplete(data);
    } catch (e) {
      return this.props.onError(e);
    }
  }

  setProcessing = (p) => {
    this.setState({
      processing: p
    })
  }

  render() {
    const {
      apiKey,
      label,
      amount,
      email:propEmail
    } = this.props;

    const {
      name,
      email,
      processing
    } = this.state;

    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div className="stripe-modal-inner">
        <div className="stripe-modal-inner-header">
          <LogoSvg />
          { label }
          <hr />
          {
            email
              ? (
                <small>
                  { email }
                </small>
              )
              : null
          }
          <a className="stripe-modal-inner-header-close" onClick={this.close} href="javascript:void(0)">×</a>
        </div>
        <div className="stripe-modal-inner-body">
          <StripeProvider apiKey={apiKey}>
            <Elements>
              <StripeForm
                setProcessing={this.setProcessing}
                processing={processing}
                setActive={this.setActive}
                onComplete={this.handleComplete}
                amount={amount}
                handleChange={this.handleChange}
                name={name}
                hasEmail={!!propEmail}
                email={email}
              />
            </Elements>
          </StripeProvider>
        </div>
      </div>
    );
  }
}
